module.exports = __webpack_public_path__ + "img/generac.2d0eb1fb.png";